module.exports = __webpack_public_path__ + "img/point-3@2x.44bec6e3.jpg";